import "./Home.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import ImpactVisuelImmobilier from "./sections/ImpactVisuelImmobilier";
import OurCollectiveMission from "./sections/OurCollectiveMission";
import WorkflowBenefits from "./sections/WorkflowBenefits";
import EngineeredForExcellence from "./sections/EngineeredForExcellence";
import ThePerfectProtocol from "./sections/ThePerfectProtocol";
import VotreProjetIci from "./sections/VotreProjetIci";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <VoltMainHeader />
      <ImpactVisuelImmobilier />
      <OurCollectiveMission />
      <WorkflowBenefits />
      <EngineeredForExcellence />
      <ThePerfectProtocol />
      <VotreProjetIci />
      <Footer />
    </div>;
}